import { useState, useEffect, useCallback } from 'react';

const NEWS_SCROLLING_KEY = 'news-portal-scrolling-enabled';

export const useNewsScrollingSetting = () => {
  const [isScrollingEnabled, setIsScrollingEnabled] = useState(() => {
    const stored = localStorage.getItem(NEWS_SCROLLING_KEY);
    return stored === 'true';
  });

  const updateSetting = useCallback((enabled: boolean) => {
    localStorage.setItem(NEWS_SCROLLING_KEY, String(enabled));
    setIsScrollingEnabled(enabled);
    window.dispatchEvent(
      new CustomEvent('news-scrolling-changed', { detail: enabled }),
    );
  }, []);

  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === NEWS_SCROLLING_KEY) {
        setIsScrollingEnabled(e.newValue === 'true');
      }
    };

    const handleCustomEvent = (e: CustomEvent<boolean>) => {
      setIsScrollingEnabled(e.detail);
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener(
      'news-scrolling-changed',
      handleCustomEvent as EventListener,
    );

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener(
        'news-scrolling-changed',
        handleCustomEvent as EventListener,
      );
    };
  }, []);

  return { isScrollingEnabled, updateSetting };
};
